export default __webpack_public_path__ + "static/media/arrow_upward_purple.d817b103.svg";